import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Megaphone, Globe, Calendar, Heart } from 'lucide-react';

const Testimonials: React.FC = () => {
  const testimonials = [
    {
      name: 'Mr. Asmon Fredrick',
      role: 'CEO',
      company: 'Aamisha Foods Pvt Ltd',
      content: 'An excellent design agency with a helpful team who really understand customer requirements and work alongside us to achieve our KRA\'s.',
    },
    {
      name: 'Mr. Harjeet Singh',
      role: 'Business Owner',
      company: 'IndWheels',
      content: 'Amazing experience with CDBS! Professional team, timely delivery, and creative results. Perfect for all digital marketing and designing needs.',
    },
    {
      name: 'Mr. Darwin Samuel',
      role: 'Business Owner',
      company: 'Abu Dhabi, UAE',
      content: 'Loved working with CDBS! Their designs, digital marketing strategy, and overall support have helped our business grow. Super friendly team and great results!',
    },
    {
      name: 'Mr. Ratnesh Rathi',
      role: 'Director',
      company: 'Vertical Growth Financial Advisors',
      content: 'Color Drop Business Solutions is a reliable partner for digital marketing, graphic designing, websites, and overall brand growth. They understand the client\'s vision and execute it perfectly. Their professionalism, creativity, and timely support make them stand out. Truly satisfied!',
    },
    {
      name: 'Ms. Tanvi Dua',
      role: 'Business Owner',
      company: 'Oslo, Norway',
      content: 'Color Drop Business Solutions delivers exceptional digital marketing and creative services. Their team is skilled, responsive, and truly understands business needs. From social media to website work, everything is top quality. Highly recommended for anyone looking to grow their brand!',
    },
    {
      name: 'Dr. Abhijeet Bhasin',
      role: 'Owner',
      company: 'Olive Dental & Physio',
      content: 'CDBS has been managing our social media and design work, and the difference is clearly visible. Creative ideas, consistent posting, and great communication. Excellent service!',
    },
    {
      name: 'Mr. Vaibhav Solanki',
      role: 'Owner',
      company: 'The Ashoka Hotel',
      content: 'Working with Color Drop Business Solutions has been an excellent experience. Their team handles our social media, designing, and marketing needs with great creativity and professionalism. We\'ve seen a noticeable improvement in our online visibility and engagement. Their timely support and understanding of the hospitality industry make them a valuable partner. Highly recommended!',
    },
    {
      name: 'Mr. Bhupendra Singh',
      role: 'Founder',
      company: 'Robotronix India',
      content: 'I had an excellent experience with this digital marketing company CDBS Indore. Their team is professional, knowledgeable, and results-driven. If you\'re looking for a reliable and effective digital marketing partner, I highly recommend this company! They truly go above and beyond.',
    },
  ];

  const stats = [
    { icon: Megaphone, value: '1365+', label: 'Ad Campaigns Done' },
    { icon: Globe, value: '18+', label: 'Location Served' },
    { icon: Calendar, value: '12+', label: 'Years Experience' },
    { icon: Heart, value: '560', label: 'Satisfied Clients' },
  ];

  const industries = [
    "Retail & E-Commerce",
    "Real Estate & Property Developers",
    "Education & EdTech",
    "Hospitality",
    "Food & Beverages",
    "Health & Wellness",
    "Beauty, Salon & Personal Care",
    "Finance, Insurance & Investment",
    "IT & Software Companies",
    "NGOs & Social Organizations",
    "Medical Practitioners",
    "Construction & Infrastructure",
    "Travel Influencers & Content Creators",
    "Public Figures & Personal Branding"
  ];


  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-24 bg-gradient-to-br from-primary-50 to-accent-50">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-serif font-bold mb-6">
              Client <span className="text-gradient">Testimonials</span>
            </h1>
            <p className="text-xl text-neutral-600 leading-relaxed">
              Don't just take our word for it. Here's what our clients say about working with CDBS to elevate their digital presence and grow their business.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: false }}
                className="text-center"
              >
                <div className="w-16 h-16 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <stat.icon className="w-8 h-8 text-white" />
                </div>
                <div className="text-3xl md:text-4xl font-bold text-primary-600 mb-2">{stat.value}</div>
                <div className="text-neutral-600">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-24 bg-neutral-50">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-serif font-bold mb-6">What Our Clients Say</h2>
            <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
              Real feedback from businesses across industries who have transformed their digital presence with our help.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={testimonial.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: false }}
                className="group"
              >
                <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col">
                  {/* Content */}
                  <p className="text-neutral-700 mb-6 leading-relaxed italic flex-grow">
                    "{testimonial.content}"
                  </p>

                  {/* Author */}
                  <div className="flex items-center pt-4 border-t border-neutral-100">
                    {/* Google Logo */}
                    <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 shadow-sm border border-neutral-200">
                      <svg className="w-7 h-7" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                      </svg>
                    </div>

                    {/* Author Info */}
                    <div className="flex-grow">
                      <div className="font-semibold text-neutral-900">{testimonial.name}</div>
                      <div className="text-sm text-neutral-600">{testimonial.role}, {testimonial.company}</div>
                    </div>
                  </div>


                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Testimonial */}
      <img src="/worldMap.jpg" alt="Featured Testimonial" className="w-full h-full object-cover rounded-2xl" />

      {/* Industries Section */}
      <section className="py-24 bg-neutral-50">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-serif font-bold mb-6">Industries We Serve</h2>
            <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
              We work with businesses across various industries, bringing our expertise to help them excel in the digital landscape.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {industries.map((industry, index) => (
              <motion.div
                key={industry}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: false }}
                whileHover={{
                  scale: 1.05,
                  y: -8,
                  transition: { duration: 0.3 }
                }}
                className="group bg-white rounded-lg p-6 text-center shadow-lg transition-all duration-300 cursor-pointer relative overflow-hidden"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-primary-500/10 to-accent-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-lg"></div>

                {/* Animated border on hover */}
                <div className="absolute inset-0 rounded-lg border-2 border-transparent group-hover:border-primary-400 transition-all duration-300"></div>

                {/* Content */}
                <div className="relative z-10 text-neutral-700 font-medium text-sm group-hover:text-primary-600 transition-colors duration-300">
                  {industry}
                </div>

                {/* Shine effect */}
                <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent rounded-lg"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-r from-primary-500 to-accent-500">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: false }}
          >
            <h2 className="text-4xl font-serif font-bold text-white mb-6">
              Ready to Join Our Success Stories?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Let's discuss how we can help your business achieve similar exceptional results and grow your brand.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contact" className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold hover:bg-accent-50 transition-colors duration-300 inline-flex items-center justify-center">
                Start Your Project
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
              <a href="/services" className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/30 transition-colors duration-300 inline-flex items-center justify-center">
                View Our Services
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
